/** Site-wide SEO defaults (from original Jekyll _config.yml). */
export const SITE_DEFAULTS = {
  siteName: "UXMichal.com | Smashing UX Designer",
  brandPrefix: "UXMichal.com",
  /** Production canonical origin — override with VITE_SITE_URL when needed. */
  url:
    (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, "") ||
    "https://uxmichal.com",
  description:
    "Smashing UX Designer with 15+ years of experience in product design, prototyping, and front-end development. Discover how I transform visions into user-centered digital experiences.",
  keywords:
    "UXMichal, UX Michal, UX Designer, Product Designer, User Experience Designer, Prototyping, Front-End Development, Digital Design, User-Centered Design, Figma, React, Web Design, Mobile App Design",
  image: "/images/assets/uxmichal-web-image-cover.webp",
  logo: "/image-1.png",
  twitterSite: "@lececil",
  locale: "en_US",
  personName: "Michal Cako",
  jobTitle: "Senior Product / UX Designer",
  sameAs: [
    "https://www.linkedin.com/in/lececil",
    "https://twitter.com/lececil",
  ],
} as const;

export function formatPageTitle(pageTitle?: string): string {
  if (!pageTitle?.trim()) {
    return `${SITE_DEFAULTS.brandPrefix} | Smashing UX Designer`;
  }
  return `${SITE_DEFAULTS.brandPrefix} | ${pageTitle.trim()}`;
}

export function truncateDescription(text: string, maxLength = 160): string {
  const plain = text.replace(/\s+/g, " ").trim();
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength - 1).trim()}…`;
}

export function absoluteUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_DEFAULTS.url}${normalized}`;
}

export function absoluteImageUrl(imagePath: string): string {
  return absoluteUrl(imagePath);
}
